import { BusinessTerm } from '@wix/ambassador-funnel-taxonomy-v1-business-term/types'

export enum SearchScreen {
  INITIAL,
  SEARCH_SUGGESTIONS_ACTIVE,
  SEARCH_CATEGORIES_RESULTS_ACTIVE,
}

export interface SearchStateCategory {
  businessTerm?: BusinessTerm
  businessSegmentId?: string
  index: number
}

export interface SearchState {
  screen: SearchScreen
  searchValue: string
  isCategoriesLoading: boolean
  categories: BusinessTerm[]
  selectedCategory?: SearchStateCategory
  isSearchFocused: boolean
}

export enum SearchActionType {
  SEARCH_FOCUS,
  SEARCH_SELECT_SUGGESTION,
  SEARCH_LOAD_CATEGORIES_START,
  SEARCH_LOAD_CATEGORIES_SUCCESS,
  SEARCH_CHANGE,
  SEARCH_EMPTY,
  SEARCH_BLUR,
  SEARCH_SELECT_CATEGORY,
  TO_INITIAL_SCREEN,
}

export interface SearchFocusAction {
  type: SearchActionType.SEARCH_FOCUS
}

export interface SearchBlurAction {
  type: SearchActionType.SEARCH_BLUR
}

export interface SearchEmptyAction {
  type: SearchActionType.SEARCH_EMPTY
}

export interface SearchSelectSuggestionAction {
  type: SearchActionType.SEARCH_SELECT_SUGGESTION
  suggestion: string
}

export interface SearchChangeAction {
  type: SearchActionType.SEARCH_CHANGE
  value: string
}

export interface SearchLoadCategoriesStartAction {
  type: SearchActionType.SEARCH_LOAD_CATEGORIES_START
}

export interface SearchLoadCategoriesSuccessAction {
  type: SearchActionType.SEARCH_LOAD_CATEGORIES_SUCCESS
  categories: BusinessTerm[]
}

export interface SearchSelectCategoryAction {
  type: SearchActionType.SEARCH_SELECT_CATEGORY
  category: SearchStateCategory
}

export interface SearchToInitialScreenAction {
  type: SearchActionType.TO_INITIAL_SCREEN
}

export type SearchAction =
  | SearchFocusAction
  | SearchBlurAction
  | SearchEmptyAction
  | SearchLoadCategoriesStartAction
  | SearchSelectSuggestionAction
  | SearchChangeAction
  | SearchSelectCategoryAction
  | SearchLoadCategoriesSuccessAction
  | SearchToInitialScreenAction
